import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BookingModel } from 'src/app/Api_Module';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'crg-comfirm-modal',
  templateUrl: './comfirm-modal.component.html'
})
export class ComfirmModalComponent implements OnInit {

  @Input() buttonText?: string;
  @Input() buttonClass?: string;
  @Input() buttonIcon?: string;
  @Output() accept: EventEmitter<any> = new EventEmitter();


  constructor(private modalService: NgbModal) {
  }

  ngOnInit() {
  }

  openLg(content) {
    this.modalService.open(content, { size: 'lg' });
  }

  close(alert: any) {
    // this.alert = null;
  }

  ok() {
    this.accept.emit('User clicked ok');
    this.modalService.dismissAll('ok');
  }

}
